export default {
  PERMISSION_TYPE_TRANZIT: 'tranzit',
  PERMISSION_TYPE_TOUR: 'tour',
};
